module.exports = __webpack_public_path__ + "static/media/home-image_mobile.bf37742b.png";